import { Space, Tag, Tooltip, Typography } from "antd";

import { connectionVerdict } from "@hedefuni/domain/connection";

import type { ConnectionSide, ConnectionSummary } from "../types";

// A lesson's connection on each side (product decision 2026-10-13): the speed test before
// joining and the problems during the lesson, so staff see whether a complaint came from
// someone's internet.

const VERDICT = {
  GOOD: { color: "green", label: "İyi" },
  FAIR: { color: "gold", label: "Orta" },
  WEAK: { color: "red", label: "Zayıf" },
} as const;

const mbps = (value: number) => value.toLocaleString("tr-TR", { maximumFractionDigits: 1 });

export function ConnectionSideTag({ label, side }: { label: string; side: ConnectionSide }) {
  if (!side.speed && side.problems === 0) {
    return <Typography.Text type="secondary">{label}: test yok</Typography.Text>;
  }
  const verdict = side.speed ? VERDICT[connectionVerdict(side.speed)] : null;
  return (
    <Space size={4} wrap>
      <Typography.Text>{label}:</Typography.Text>
      {side.speed && verdict ? (
        <Tooltip
          title={`İndirme ${mbps(side.speed.downloadMbps)} Mbps · Yükleme ${mbps(side.speed.uploadMbps)} Mbps · Gecikme ${side.speed.latencyMs} ms`}
        >
          <Tag color={verdict.color}>
            {verdict.label} · ↓{mbps(side.speed.downloadMbps)} ↑{mbps(side.speed.uploadMbps)}
          </Tag>
        </Tooltip>
      ) : null}
      {side.problems > 0 ? <Tag color="red">{side.problems} kopma/zayıflama</Tag> : null}
    </Space>
  );
}

export function ConnectionCell({ connection }: { connection: ConnectionSummary }) {
  return (
    <Space direction="vertical" size={2}>
      <ConnectionSideTag label="Öğrenci" side={connection.student} />
      <ConnectionSideTag label="Eğitmen" side={connection.tutor} />
    </Space>
  );
}
